// src/App.tsx
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from "react-router-dom";
import { Flex, Button, Box } from "@chakra-ui/react";
import ApiKeyList from "./ApiKeyList";
import CreateApiKey from "./CreateApiKey";
import RetrieveKey from "./RetrieveKey";
import UsagePlanManager from "./UsagePlanManager";
import AttachPlanPage from "./AttachPlanPage";
import logo from "./assets/logo.png";
import { AuthProvider, useAuth } from "./auth/AuthProvider";
import ProtectedRoute from "./auth/ProtectedRoute";
import CustomLogin from "./auth/CustomLogin";

const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/usage-plans", label: "Manage Usage Plans" },
  { to: "/create", label: "Create API Key" },
];

function AppHeader() {
  const location = useLocation();
  const { isAuthenticated, logout, email } = useAuth();

  if (location.pathname === "/login" || location.pathname === "/retrieveapikeys") {
    return null;
  }

  return (
    <Flex
      justify="space-between"
      align="center"
      px={6}
      py={3}
      bg="black"
      position="sticky"
      top={0}
      zIndex={1000}
      boxShadow="sm"
    >
      {/* Left: Navigation buttons */}
      <Flex flex="1" gap={4} align="center">
        {isAuthenticated && NAV_LINKS.map(({ to, label }) => {
          const isActive = to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);
          return (
            <Link key={to} to={to}>
              <Button
                colorScheme="yellow"
                variant={isActive ? "solid" : "outline"}
                fontWeight={600}
                opacity={isActive ? 1 : 0.7}
              >
                {label}
              </Button>
            </Link>
          );
        })}
      </Flex>

      {/* Center: Logo (always centered) */}
      <Box flex="1" display="flex" justifyContent="center">
        <img src={logo} alt="Logo" style={{ width: 180, height: "auto" }} />
      </Box>

      {/* Right: Actions */}
      <Flex flex="1" justify="flex-end" gap={4} align="center">
        {isAuthenticated ? (
          <>
            <Button
              colorScheme="yellow"
              variant="outline"
              fontWeight={600}
              onClick={logout}
            >
              Sign out
            </Button>
            {email && (
              <Box ml={2} color="yellow.300" fontWeight="semibold">
                {email}
              </Box>
            )}
          </>
        ) : (
          <Link to="/login">
            <Button colorScheme="yellow" variant="outline" fontWeight={600}>
              Sign in
            </Button>
          </Link>
        )}
      </Flex>
    </Flex>
  );
}



export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppHeader />
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<CustomLogin />} />
          <Route path="/retrieveapikeys" element={<RetrieveKey />} />

          {/* Protected routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <ApiKeyList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/create"
            element={
              <ProtectedRoute>
                <CreateApiKey />
              </ProtectedRoute>
            }
          />
          <Route
            path="/usage-plans"
            element={
              <ProtectedRoute>
                <UsagePlanManager />
              </ProtectedRoute>
            }
          />
          <Route
            path="/attach-plan/:keyId"
            element={
              <ProtectedRoute>
                <AttachPlanPage />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}
